/** Shared substring-match logic for client-side search (navbar search, leaderboard browser). */

export function normalizeQuery(raw: string): string {
  return raw.trim().toLowerCase()
}

/** `q` must already be normalized (see `normalizeQuery`). */
export function matchesQuery(q: string, fields: (string | undefined)[]): boolean {
  if (!q) return false
  return fields.some(f => f?.toLowerCase().includes(q))
}
